import React from "react";
import PropTypes from "prop-types";
import { Tooltip, Whisper } from "rsuite";
import TruncatedText from "./TruncatedText";
import "./SummaryTooltipCell.scss";

const defaultGetLabel = (item) => {
  if (item == null) return "-";
  if (typeof item === "string") return item;
  return item.clientName || item.clientCode || item.name || "-";
};

const SummaryTooltipCell = ({
  items,
  getLabel = defaultGetLabel,
  emptyText = "-",
}) => {
  if (!items || items.length === 0) return emptyText;

  const [first, ...rest] = items;
  const remainingCount = rest.length;

  return (
    <div className="summary-tooltip-cell">
      {remainingCount === 0 ? (
        // Single item: no "+N" tooltip exists, so show the full label in a
        // tooltip when it overflows.
        <TruncatedText
          text={getLabel(first)}
          className="summary-tooltip-cell__primary"
        />
      ) : (
        <span className="summary-tooltip-cell__primary">{getLabel(first)}</span>
      )}
      {remainingCount > 0 && (
        <Whisper
          placement="top"
          trigger="hover"
          speaker={
            <Tooltip className="summary-tooltip">
              <ul className="summary-tooltip-list">
                {items.map((item, index) => (
                  <li key={index}>{getLabel(item)}</li>
                ))}
              </ul>
            </Tooltip>
          }
        >
          <span className="summary-tooltip-cell__count">+{remainingCount}</span>
        </Whisper>
      )}
    </div>
  );
};

SummaryTooltipCell.propTypes = {
  items: PropTypes.array,
  getLabel: PropTypes.func,
  emptyText: PropTypes.string,
};

export default SummaryTooltipCell;
